/**
 * 設定値（localStorage）の読み書き
 *
 * 既存キーは名前・型・意味を変えない（技術仕様書 §5）。
 * 追加キーは無ければ既定値で動く。
 */

const KEYS = {
  evStep: 'zn.settings.evStep',             // '1' | '0.5' | '0.333'（既定 ⅓）
  showApertureSS: 'zn.settings.showApertureSS', // '1' | '0'
  baseFov: 'zn.settings.deviceBaseFov',
  autoDarkroom: 'zn.dev.autoDarkroom',      // '1' | '0'（既定 on）
  agitateBeep: 'zn.dev.agitateBeep',        // '0' で無効（既定 on）
  gps: 'zn.gps.enabled',                    // '0' で無効（既定 on）
  darkroom: 'zn.darkroom',                  // '1' | '0'
  meterInput: 'zn.settings.meterInput',     // 'ev' | 'sek'
  inputStyle: 'zn.settings.inputStyle',     // 'drum' | 'arc'
  sekAperture: 'zn.settings.sekAperture',   // '11' など
  sekStep: 'zn.settings.sekStep',           // '1' | '1/3'
  sekTenth: 'zn.settings.sekTenth',         // '1' | '0'
  darkLevel: 'zn.settings.darkLevel',       // 'normal' | 'dim' | 'deep'（暗室モードの明るさ）
  pinLabels: 'zn.settings.pinLabels',       // よく使うラベル（JSON 配列）
};

function get(key, def) {
  try {
    const v = localStorage.getItem(key);
    return v == null ? def : v;
  } catch { return def; }
}
function set(key, value) {
  try { localStorage.setItem(key, String(value)); } catch {}
}

export const prefs = {
  get evStep() {
    const v = get(KEYS.evStep, '0.333');
    return v === '1' ? 1 : v === '0.5' ? 0.5 : 1 / 3;
  },
  set evStep(v) { set(KEYS.evStep, v === 1 ? '1' : v === 0.5 ? '0.5' : '0.333'); },

  get showApertureSS() { return get(KEYS.showApertureSS, '1') !== '0'; },
  set showApertureSS(on) { set(KEYS.showApertureSS, on ? '1' : '0'); },

  get autoDarkroom() { return get(KEYS.autoDarkroom, '1') !== '0'; },
  set autoDarkroom(on) { set(KEYS.autoDarkroom, on ? '1' : '0'); },

  get agitateBeep() { return get(KEYS.agitateBeep, '1') !== '0'; },
  set agitateBeep(on) { set(KEYS.agitateBeep, on ? '1' : '0'); },

  get gps() { return get(KEYS.gps, '1') !== '0'; },
  set gps(on) { set(KEYS.gps, on ? '1' : '0'); },

  get darkroom() { return get(KEYS.darkroom, '0') === '1'; },
  set darkroom(on) { set(KEYS.darkroom, on ? '1' : '0'); },

  get meterInput() { return get(KEYS.meterInput, 'ev') === 'sek' ? 'sek' : 'ev'; },
  set meterInput(v) { set(KEYS.meterInput, v === 'sek' ? 'sek' : 'ev'); },

  get inputStyle() { return get(KEYS.inputStyle, 'drum') === 'arc' ? 'arc' : 'drum'; },
  set inputStyle(v) { set(KEYS.inputStyle, v === 'arc' ? 'arc' : 'drum'); },

  get sekAperture() { return get(KEYS.sekAperture, '11'); },
  set sekAperture(v) { set(KEYS.sekAperture, v); },

  get sekStep() { return get(KEYS.sekStep, '1') === '1/3' ? '1/3' : '1'; },
  set sekStep(v) { set(KEYS.sekStep, v === '1/3' ? '1/3' : '1'); },

  get darkLevel() {
    const v = get(KEYS.darkLevel, 'normal');
    return ['normal', 'dim', 'deep'].includes(v) ? v : 'normal';
  },
  set darkLevel(v) { set(KEYS.darkLevel, ['normal', 'dim', 'deep'].includes(v) ? v : 'normal'); },

  get pinLabels() {
    try {
      const arr = JSON.parse(get(KEYS.pinLabels, 'null'));
      if (Array.isArray(arr)) return arr.filter((x) => typeof x === 'string').slice(0, 24);
    } catch {}
    return ['空', '雲', '影', '岩肌', '樹皮', '葉', '雪', '肌', '白壁', '水面'];
  },
  set pinLabels(arr) { set(KEYS.pinLabels, JSON.stringify((arr || []).slice(0, 24))); },

  get sekTenth() { return get(KEYS.sekTenth, '1') !== '0'; },
  set sekTenth(on) { set(KEYS.sekTenth, on ? '1' : '0'); },
};
